// extracted by mini-css-extract-plugin
export default {"table":"TableWrapper_table__73GXI"};